module.exports = __webpack_public_path__ + "media/homepage/header-collage@5x-26b144de.png";